export default __webpack_public_path__ + "media/images/temporary/medium-pumpkin-9c8d0ba286cfc95befa8c575abe48cbc.jpg";